/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type {ConcreteFragment} from 'relay-runtime';
export type ReportHeader_devices = {| |};
*/


const fragment /*: ConcreteFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ReportHeader_devices",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "ReportFilters_devices",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "EditReportDialog_devices",
      "args": null
    }
  ],
  "type": "DeviceConnection"
};

module.exports = fragment;



// WEBPACK FOOTER //
// ./src/scenes/Report/components/ReportWrapper/components/ReportHeader/__generated__/ReportHeader_devices.graphql.js